import i18n from "../../i18n";
import { useMemo } from "react";
import tooltipStyles from "./tooltip.module.css";

function Tooltip({
  children,
  isShown,
  position,
  multiline,
}: {
  children: string;
  isShown: boolean;
  position?: string;
  variant?: string;
  multiline?: boolean;
}) {
  const lang = i18n.language;

  const dir = useMemo(() => {
    return lang === "he" || lang === "ar" ? "rtl" : "ltr";
  }, [lang]);
  return (
    <span
      dir={dir}
      className={`${tooltipStyles.tooltip} ${
        (position === "center" && tooltipStyles.tooltip_position_center) ||
        (position === "right" && tooltipStyles.tooltip_position_right) ||
        (position === "bottom" && tooltipStyles.tooltip_position_bottom) ||
        (position === "left" && tooltipStyles.tooltip_position_left)
      }
      ${multiline ? tooltipStyles.tooltip_multiline : ""}
      ${isShown && tooltipStyles.tooltip_visible}`}
    >
      {children}
    </span>
  );
}

export default Tooltip;
